export default __webpack_public_path__ + "static/media/lexus.4e251da9.webp";